import form from './form';
import register from './register';
import pages from "./pages";
import apps_sidebar from './apps_sidebar';
import components from './components';

export default {
    form,
    register,
    "offline_mode": {
        "online": "Sie sind wieder online.",
        "offline": "Wir können Ihre Internetverbindung nicht mehr erkennen.",
        "banner": {
        "text": "Achtung, Ihre Internetverbindung scheint ein Problem zu haben."
        }
    },
    "pagination": {
        "prev": "<",
        "next": ">"
    },
    "table": {
        "empty": "Zur Zeit keine Informationen."
    },
    "misc": {
        "confirm_page_leave": "Sind Sie sicher, dass Sie diese Seite verlassen wollen? Ihre Änderungen gehen dann verloren.",
        "confirm": "Sind Sie sicher, dass Sie fortfahren wollen?",
        "back_button": "Zurück",
        "date_time": "Am {Datum} um {Uhrzeit}"
    },
    help_submenu: {
        label: 'Help',
        help: {
            link: 'https://pro.trustup.be/aide',
            text: "Hilfezentrum",
        },
        support: {
            link: 'https://pro.trustup.be/support/',
            text: "Support kontaktieren",
        },
        chat: {
            text: "Chat",
        }
    },
    components,
    pages,
    apps_sidebar
}